// import bootstrap from 'bootstrap';
import * as bootstrap from 'bootstrap';

export default function initAccordionMedia() {
  const dataset = [];
  let timerResize;
  const matchMobile = window.matchMedia('(max-width: 767px)');
  function changePlace() {
    dataset.forEach(function (data) {
      data.array.forEach(function (obj) {
        if (matchMobile.matches) {
          if (obj.replace) {
            obj.children.forEach(function (child) {
              obj.oldPlace.append(child);
            });
            obj.replace = false;
          }
        } else {
          if (!obj.replace) {
            obj.children.forEach(function (child) {
              obj.listItem.append(child);
            });
            obj.replace = true;
          }
        }
      });
    })
  }

  document.querySelectorAll('.accordion').forEach(function (holder) {
    const target = document.querySelector(holder.dataset.targetList);
    if (!target) return;
    const items = holder.querySelectorAll('.accordion-item');
    const data = {
      holder,
      animationStarted: false,
      animationEnded: false,
      array: []
    }
    const hiddenClass = 'hidden';
    let activeIndex = null;
    let allHidden = false;
    let hiddenChild = null;
    const buttons = holder.querySelectorAll('.accordion-button');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        data.animationEnded = true;
        clearTimeout(data.timerAnimation);
      });
    });

    const detectOpened = () => data.array.some((obj) => obj.opened);

    items.forEach(function (item, index) {
      const oldPlace = item.querySelector('.replace-holder');
      const collapse = item.querySelector('.accordion-collapse');
      const listItem = document.createElement('li');
      const bsCollapse = new bootstrap.Collapse(collapse, {
        toggle: false
      });

      const children = [...oldPlace.children];
      const obj = {
        oldPlace,
        opened: false,
        replace: false,
        children,
        listItem,
        collapse,
        bsCollapse: bsCollapse
      }

      if (collapse.classList.contains('show')) {
        obj.opened = true;
        listItem.classList.remove(hiddenClass)
      } else {
        listItem.classList.add(hiddenClass)
      }
      data.array.push(obj);
      target.append(listItem);

      collapse.addEventListener('hide.bs.collapse', event => {
        // do something...
        activeIndex = null;
        listItem.classList.add(hiddenClass)
        obj.opened = false;
        if (!detectOpened()) {
          allHidden = true;
          hiddenChild = listItem;
          listItem.classList.remove(hiddenClass);
        }
      })
      collapse.addEventListener('show.bs.collapse', event => {
        activeIndex = index;
        if (hiddenChild) {
          hiddenChild.classList.add(hiddenClass);
          hiddenChild = null;
        }
        listItem.classList.remove(hiddenClass);
        obj.opened = true;
        // if (!data.animationEnded) {
        //   let nextIndex = (index === items.length - 1) ? 0 : index + 1;
        //   clearTimeout(data.timerAnimation);
        //   data.timerAnimation = setTimeout(() => {
        //     data.array[nextIndex].bsCollapse.toggle();
        //   }, 3000);

        // }
      })
    })

    dataset.push(data);

  });

  if (!dataset.length) return;

  changePlace();
  window.addEventListener('resize', function () {
    clearTimeout(timerResize);
    timerResize = setTimeout(function () {
      changePlace();
    }, 300)
  });


  window.addEventListener('scroll', function (e) {
    if (!dataset.length) return;
    dataset.forEach(function (obj) {
      if (obj.animationStarted || obj.animationEnded) return;
      if (obj.holder.offsetTop <= window.scrollY + (window.innerHeight / 5)) {
        obj.animationStarted = true;

        // obj.array.forEach((item, i) => {
        //   if (item.opened) {
        //     let nextCollapse = obj.array[i + 1].bsCollapse;
        //     obj.timerAnimation = setTimeout(() => {
        //       nextCollapse.toggle();
        //     }, 3000);
        //   }
        // })
      }
    });
  });
}